import React from 'react';
import clsx from 'clsx';

import useIsLoggedIn from 'hooks/useIsLoggedIn';
import styles from 'styles/components/agency/Dashboard.module.scss';

const Header = ({
  title,
  children,
  hasChildren = false,
  subtitle = false,
  rightBtn,
  columnDirection,
}) => {
  const isLoggedIn = useIsLoggedIn();

  return (
    <div
      className={clsx(
        styles.header,
        { [styles.center]: hasChildren },
        { [styles.notLoggedInPadding]: !isLoggedIn }
      )}
      style={columnDirection ? { flexDirection: 'column' } : {}}
    >
      <div className={styles.title}>
        <h1 style={{ display: 'flex', alignItems: 'center' }}>{title}</h1>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        {rightBtn && <div style={{ marginLeft: 'auto' }}>{rightBtn}</div>}
      </div>

      {children}
    </div>
  );
};

export default Header;
